import { h } from 'preact';

export function IconEnvelopeOpen({ width = 30, height = 30, fill = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
      fill="none"
      aria-hidden="true"
      focusable="false"
      role="presentation"
      class="icon-envelope-open"
    >
      <path
        class="fa-secondary"
        opacity="0.2"
        fill={fill}
        d="M64 64v64.5 79.6 41.6c57.6 42.6 115.1 85.3 172.7 127.9 5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4C332.9 335 390.5 292.3 448 249.7v-41.6-79.6V64c0-17.7-14.3-32-32-32h-98.2H194.2H96C78.3 32 64 46.3 64 64zm96 80c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"
      />
      <path
        class="fa-primary"
        opacity="0.5"
        fill={fill}
        d="M511.8 202.5c-1.6-18.1-10.9-34.9-25.7-45.8L448 128.5v79.6v41.6l63.8-47.2zM512 448V242.1L294.4 403.3C283.3 411.6 269.8 416 256 416s-27.3-4.4-38.4-12.7L0 242.1V448c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64zM64 249.7v-41.6-79.6L25.9 156.7C11.1 167.6 1.8 184.4.2 202.5L64 249.7zM289.5 11.1C279.8 3.9 268.1 0 256 0s-23.8 3.9-33.5 11L194.2 32h123.5L289.5 11.1zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
      />
    </svg>
  );
}
